// extracted by mini-css-extract-plugin
export default {"aboutPageWrapper":"About_aboutPageWrapper__8eDcu","dropDownArrow":"About_dropDownArrow__87N4H"};